import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import client from "../api/client";

export default function InvoiceTemplatePrintPage() {
  const { id } = useParams();

  const [blocks, setBlocks] = useState([]);

  const invoiceData = {
    CompanyName: "VR Tech Solutions",
    CompanyAddress: "Hyderabad, Telangana",
    CompanyGSTIN: "36ABCDE1234F1Z5",

    CustomerName: "ABC Traders",
    CustomerAddress: "Kukatpally, Hyderabad",
    CustomerGSTIN: "36XYZAB1234F1Z8",

    InvoiceNo: "INV-1001",
    InvoiceDate: "26-Apr-2026",
    PaymentMode: "CREDIT",

    Subtotal: "10,000.00",
    CGST: "900.00",
    SGST: "900.00",
    IGST: "0.00",
    GrandTotal: "11,800.00",
    AmountInWords: "Eleven Thousand Eight Hundred Only",

    Items: [
      {
        ItemName: "Laptop",
        HSN: "8471",
        Qty: 1,
        Rate: "10,000.00",
        GST: "18%",
        Amount: "11,800.00",
      },
    ],
  };

  useEffect(() => {
    loadTemplate();
  }, []);

  const loadTemplate = async () => {
    const res = await client.get(`/invoice-templates/${id}`);
    const parsed = JSON.parse(res.data.templateJson);
    setBlocks(parsed.blocks || []);
  };

  const replacePlaceholders = (value) => {
    if (!value) return "";

    let output = value;

    Object.keys(invoiceData).forEach((key) => {
      if (key !== "Items") {
        output = output.replaceAll(`{{${key}}}`, invoiceData[key]);
      }
    });

    return output;
  };

  const printInvoice = () => {
    window.print();
  };

  return (
    <div className="container-fluid mt-3">
      <div className="no-print mb-3">
        <button className="btn btn-primary" onClick={printInvoice}>
          Print Invoice
        </button>
      </div>

      <div
        className="invoice-print-page bg-white mx-auto position-relative"
        style={{
          width: "794px",
          height: "1123px",
          border: "1px solid #ccc",
        }}
      >
        {blocks.map((block) => (
          <div
            key={block.id}
            style={{
              position: "absolute",
              left: block.x,
              top: block.y,
              width: block.width,
              height: block.height,
              fontSize: block.fontSize,
              fontWeight: block.bold ? "bold" : "normal",
              textAlign: block.align || "left",
              overflow: "hidden",
              border: block.type === "box" ? "1px solid #000" : "none",
              padding: "4px",
            }}
          >
            {block.type === "text" && replacePlaceholders(block.value)}

            {block.type === "box" && ""}

            {block.type === "table" && (
              <table className="table table-bordered table-sm mb-0">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>HSN</th>
                    <th>Qty</th>
                    <th>Rate</th>
                    <th>GST</th>
                    <th>Total</th>
                  </tr>
                </thead>

                <tbody>
                  {invoiceData.Items.map((item, index) => (
                    <tr key={index}>
                      <td>{item.ItemName}</td>
                      <td>{item.HSN}</td>
                      <td>{item.Qty}</td>
                      <td>{item.Rate}</td>
                      <td>{item.GST}</td>
                      <td>{item.Amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        ))}
      </div>

      <style>
        {`
          @media print {
            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            .no-print {
              display: none !important;
            }

            .invoice-print-page {
              border: none !important;
              margin: 0 !important;
              width: 794px !important;
              height: 1123px !important;
            }
          }
        `}
      </style>
    </div>
  );
}
